<div class="mb-5 header">
  <div class="header-title">User Preferences</div>
  <p class="description">
    Update your notification, display, and experience settings for this app.
  </p>
</div>

<mat-form-field>
  <mat-label>Log level</mat-label>

  <mat-select
    [value]="(loggingState$ | async).level"
    (selectionChange)="selectLogLevel($event)"
  >
    @for (option of logLevelOptions; track option) {
      <mat-option [value]="option.value">{{ option.label }}</mat-option>
    }
  </mat-select>
</mat-form-field>
